import React from "react";

// DisclaimerBanner — the persistent trust/compliance banner that renders
// wherever risk flags appear (PropertyDetail's Risk flags section and the
// public NC tax-foreclosure education page). Required by the implementation
// guide's foundation feature 3 + cross-cutting guardrail #2: risk analysis is
// never presented as a title search, a title opinion, or legal advice.
//
// Copy is counsel-reviewed-before-launch territory — keep edits in lockstep
// with docs/nc-tax-foreclosure (the guardrails section).

interface DisclaimerBannerProps {
  /** Optional extra class for layout context (e.g. spacing on a public page). */
  className?: string;
}

const DisclaimerBanner: React.FC<DisclaimerBannerProps> = ({ className }) => (
  <div
    className={"risk-disclaimer" + (className ? " " + className : "")}
    role="note"
    aria-label="Risk-flag disclaimer"
  >
    <span className="risk-disclaimer-icon" aria-hidden="true">
      ⚖
    </span>
    <span className="risk-disclaimer-body">
      <strong>Parcely is an information tool, not a title search, a title opinion, or legal advice.</strong>{" "}
      Risk flags are automated signals, not a guarantee — verify everything with a full title search
      and an NC attorney before bidding.
    </span>
  </div>
);

export default DisclaimerBanner;
